/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.tiposbodegas': 'Tipos Bodegas',
  'tiposBodegas.agregarTiposBodegas': 'Crear Tipos Bodegas',
  'tiposBodegas.modificarTiposBodegas': 'Editar Tipos Bodegas',
  'tiposBodegas.tipoBodegaId': 'Tipo Bodega Id',
  'tiposBodegas.empresaId': 'Empresa Id',
  'tiposBodegas.tipoBodegaDescripcion': 'Tipo Bodega Descripción',
  'tiposBodegas.VerTiposBodegas': 'Ver Tipos Bodegas',
  'tiposBodegas.RegistroDuplicado': 'Registro Duplicado',
};
